import { Injectable } from '@angular/core';
import { TableColumnProvider } from '../../../interfaces/table-column-provider';
import { TableColumnService } from '../services/table-column.service';
import { TableColumn } from '../../../models/table-column';
import { Invoice } from '../../../models/invoice';
import { CurrencyService } from '../services/currency.service';
import { Clock } from '../../../utils/clock';
import { InvoiceColumnEnum } from '../../../enum/invoice-column.enum';
import { EntityEnum } from '../../../enum/entity.enum';

@Injectable({
    providedIn: 'root'
})
export class InvoiceColumnsService implements TableColumnProvider {

    constructor(private tableColumnService: TableColumnService, private currencyService: CurrencyService) {
        this.tableColumnService.registerProvider(this);
    }

    get(id: string): TableColumn {
        switch (id) {
            case InvoiceColumnEnum.INVOICE_REFERENCE:
                return {
                    id: InvoiceColumnEnum.INVOICE_REFERENCE,
                    caption: $localize`Number`,
                    width: 150,
                    sort: 'reference',
                    render: (invoice: Invoice) => invoice.reference
                };
            case InvoiceColumnEnum.INVOICE_DATE:
                return {
                    id: InvoiceColumnEnum.INVOICE_DATE,
                    caption: $localize`Date`,
                    width: 150,
                    sort: 'date',
                    render: (invoice: Invoice) => Clock.parseToIso(invoice.date)
                };
            case InvoiceColumnEnum.INVOICE_TOTAL:
                return {
                    id: InvoiceColumnEnum.INVOICE_TOTAL,
                    caption: $localize`Total`,
                    width: 150,
                    sort: 'total',
                    render: (invoice: Invoice) => this.currencyService.render(invoice.total, invoice.currency)
                };
            case InvoiceColumnEnum.INVOICE_TOTAL_NET:
                return {
                    id: InvoiceColumnEnum.INVOICE_TOTAL_NET,
                    caption: $localize`Total (Net)`,
                    width: 150,
                    sort: 'totalNet',
                    render: (invoice: Invoice) => this.currencyService.render(invoice.totalNet, invoice.currency)
                };
        }
    }

    ids(): string[] {
        return [ InvoiceColumnEnum.INVOICE_REFERENCE, InvoiceColumnEnum.INVOICE_DATE, InvoiceColumnEnum.INVOICE_TOTAL, InvoiceColumnEnum.INVOICE_TOTAL_NET ];
    }

    supports(entityClass: string): boolean {
        return entityClass === EntityEnum.INVOICE;
    }
}
